import { type FC } from 'react';
import { MediaItem, Text, VStack } from '@direct-frontend/components';
import styles from './ShowMoreItem.module.css';

export type ShowMoreItemProps = { show: boolean; totalString: string; howMuchLonger: number; onClick: VoidFunction };

export const ShowMoreItem: FC<ShowMoreItemProps> = ({ show, totalString, howMuchLonger, onClick }) => {
    if (!show) {
        return null;
    }

    return (
        <MediaItem
            borderRadius="10"
            width={120}
            controls={<></>}
            title={
                <Text maxLines={4} size="s">
                    {totalString}
                </Text>
            }
            onClick={onClick}
            media={
                <VStack
                    className={styles.media}
                    alignItems="center"
                    justifyContent="center"
                    width="120px"
                    height="120px"
                >
                    <Text size="xs" color="gray" role="supplementary">
                        Ещё {howMuchLonger}
                    </Text>
                </VStack>
            }
        />
    );
};
